<button [class]="classes()" [style]="previewStyles()">
    {{ BUTTON_STYLE_TYPE_TRANSLATIONS[button().styleType] | translate }}
</button>
